module.exports = __webpack_public_path__ + "static/media/vibrantlogo.21b85878.svg";